import { gql } from '@apollo/client';
import { CART_FRAGMENT, Cart, CartVersion } from '../useCart/cart.rest';

export type AddToBagInput = {
  input: {
    data: {
      attributes: {
        availability: string;
        cart_id: string | null;
        country_code: string;
        customization: string;
        position: number;
        product_id: number;
        size: string;
        target: CartVersion;
        trunkshow_id: string | null;
        variant_id: string;
      };
      type: 'line_items';
    };
  };
};

export type AddToBagResponse = {
  addToBag: {
    data: Cart[];
  };
};

export const ADD_TO_BAG_MUTATION = gql`
  mutation AddToBagMutation($input: AddToBagInput) {
    addToBag(input: $input)
      @rest(type: "RestAddToBag", endpoint: "cart", path: "/v3.5/line_items", method: "POST") {
      data @type(name: "RestUserCartData") {
        ...CartFragment
      }
    }
  }
  ${CART_FRAGMENT}
`;
